import React from "react";

const Icon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15.338"
      height="15.263"
      viewBox="0 0 15.338 15.263"
    >
      <g
        id="Group_773"
        data-name="Group 773"
        transform="translate(-1002.485 -5073.202)"
      >
        <ellipse
          id="Ellipse_366"
          data-name="Ellipse 366"
          cx="7.263"
          cy="7.226"
          rx="7.263"
          ry="7.226"
          transform="translate(1002.891 5073.607)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.811"
        ></ellipse>
        <line
          id="Line_472"
          data-name="Line 472"
          x2="5.847"
          y2="5.816"
          transform="translate(1007.231 5077.925)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.811"
        ></line>
        <line
          id="Line_473"
          data-name="Line 473"
          x1="5.847"
          y2="5.816"
          transform="translate(1007.231 5077.925)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.811"
        ></line>
      </g>
    </svg>
  );
};

export default Icon;
